import { FC, ReactNode, useState } from 'react';

import { Drawer, Flex } from 'antd';

import useIsMobile from '@/hooks/useIsMobile';

import BurgerIcon from '@/assets/icons/burger.svg?react';

import styles from './FormMobileHeader.module.scss';

import Close from '../icons/Close';
import Logo from '../logo/Logo';

type TFormMobileHeaderProps = {
	timeline: ReactNode;
};

export const FormMobileHeader: FC<TFormMobileHeaderProps> = ({ timeline: Timeline }) => {
	const [drawerOpened, setDrawerOpened] = useState(false);

	const toggleDrawerOpen = (): void => {
		setDrawerOpened((prev) => !prev);
	};

	const isMobile = useIsMobile();

	return (
		<>
			<Flex className={styles['form-header']} justify="space-between">
				<div className={styles['logo-container']}>
					<Logo />
				</div>
				<BurgerIcon className={styles['menu-icon']} onClick={toggleDrawerOpen} />
			</Flex>
			<Drawer
				classNames={{
					body: styles['drawer-body'],
					header: styles['drawer-header'],
					content: styles['drawer-content'],
				}}
				closeIcon={<Close />}
				open={drawerOpened}
				title={
					<div className={styles['logo-container']}>
						<Logo />
					</div>
				}
				width={isMobile ? '100vw' : 375}
				onClose={toggleDrawerOpen}
			>
				<div onClick={toggleDrawerOpen}>{Timeline}</div>
			</Drawer>
		</>
	);
};
